import { Component } from '@angular/core';
import { MethodBase } from '../base/base.component';
import { AuthMethodViewModel } from '../../../../services/identity';

@Component({
  selector: 'app-method-password',
  standalone: false,
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss'
})
export class PasswordComponent extends MethodBase {

  override ngOnInit(): void {
    this.formStatusChanged.emit({ sequence: this.method.sequence, index: 0, status: 'VALID', touched: this.isEditing });
    super.ngOnInit();
  }

  setup(): void {

  }

  cancel(): AuthMethodViewModel {
    return this.method;
  }
  getMethod(): AuthMethodViewModel {
    return this.method;
  }

}
